// IS ANCHOR VISIBLE - v2.0 - June 2025 - Only one active as an option
document.addEventListener('DOMContentLoaded', function() {
    // Define the function to initialize the observer
    function isAnchorVisible(selector, options = {}) {
        const DEV = 0;
        
        // Configuration options
        const config = {
            singleActive: options.singleActive || true, // Default to multiple active elements
            threshold: options.threshold || 0.02,
            rootMargin: options.rootMargin || '0px'
        };
        
        // In single active mode:
        // - intersection ratio = how much of the element is visible (0-1)
        // - viewport coverage = how much of the viewport the visible portion occupies (0-100%)
        
        // Select all elements matching the selector
        const elements = document.querySelectorAll(selector);
        if (elements.length === 0) {
            DEV && console.log('No elements found with selector:', selector);
            return;
        }
        
        // Store all tracked elements and their viewport coverage (for single active mode)
        const trackedElements = new Map();
        
        // Create threshold array for smooth updates
        function createThresholds() {
            const thresholds = [];
            for (let i = 0; i <= 1.0; i += 0.01) {
                thresholds.push(i);
            }
            return thresholds;
        }
        
        const observerOptions = {
            // root: null, // The document viewport (default)
            rootMargin: config.rootMargin,
            threshold: config.singleActive ? createThresholds() : config.threshold
        };
        
        // Function to update active state based on highest viewport coverage (single active mode)
        function updateActiveElement() {
            let highestViewportCoverage = 0;
            let mostVisibleElement = null;
            
            // Find the element with the highest viewport coverage above threshold
            trackedElements.forEach((data, element) => {
                if (data.ratio > config.threshold && data.viewportCoverage > highestViewportCoverage) {
                    highestViewportCoverage = data.viewportCoverage;
                    mostVisibleElement = element;
                }
            });
            
            // Remove active class from all elements
            trackedElements.forEach((data, element) => {
                element.classList.remove('active');
            });
            
            // Add active class to the most visible element and update URL
            if (mostVisibleElement) {
                mostVisibleElement.classList.add('active');
                
                // Get the anchor element to update URL
                const href = mostVisibleElement.getAttribute('href');
                const anchor = href.substring(href.indexOf("#") + 1);
                const newUrl = window.location.origin + window.location.pathname + '#' + anchor;
                DEV && console.log('Active element:', anchor, 'Viewport coverage:', highestViewportCoverage.toFixed(1) + '%');
                
                // Update the URL without reloading the page
                window.history.pushState(null, '', newUrl);
            }
        }
        
        // Function to handle multiple active elements (original behavior)
        function handleMultipleActive(element, entry) {
            if (entry.intersectionRatio <= config.threshold) {
                element.classList.remove('active');
                return;
            }
            
            // Add 'active' class to the element when it comes into view
            element.classList.add('active');
            
            // Update the URL hash
            const target = entry.target;
            const newUrl = window.location.origin + window.location.pathname + '#' + target.id;
            DEV && console.log('New URL:', newUrl);
            
            // Update the URL without reloading the page
            window.history.pushState(null, '', newUrl);
        }
        
        // Iterate over each element
        elements.forEach(element => {
            const href = element.getAttribute('href');
            const anchor = href.substring(href.indexOf("#") + 1);
            const anchorElement = document.getElementById(anchor);
            
            if (!anchorElement) {
                DEV && console.log('Anchor element not found:', anchor);
                return;
            }
            
            DEV && console.log('Tracking anchor element:', anchorElement);
            
            if (config.singleActive) {
                // Initialize tracking for this element in single active mode
                trackedElements.set(element, {
                    anchorElement: anchorElement,
                    ratio: 0,
                    viewportCoverage: 0
                });
            }
            
            // Callback function to be executed when intersection changes
            const observerCallback = (entries) => {
                if (config.singleActive) {
                    // Single active mode
                    entries.forEach(entry => {
                        // Find the corresponding link element
                        let linkElement = null;
                        trackedElements.forEach((data, elem) => {
                            if (data.anchorElement === entry.target) {
                                linkElement = elem;
                            }
                        });
                        
                        if (linkElement) {
                            // Update the intersection ratio for this element
                            trackedElements.get(linkElement).ratio = entry.intersectionRatio;
                            
                            // Calculate viewport coverage (percentage of viewport occupied by visible portion)
                            const viewportArea = entry.rootBounds.width * entry.rootBounds.height;
                            const visibleArea = entry.intersectionRect.width * entry.intersectionRect.height;
                            const viewportCoverage = (visibleArea / viewportArea) * 100;
                            
                            trackedElements.get(linkElement).viewportCoverage = viewportCoverage;
                            
                            // Update active states for all elements
                            updateActiveElement();
                        }
                    });
                } else {
                    // Multiple active mode (original behavior)
                    const entry = entries[0];
                    handleMultipleActive(element, entry);
                }
            };
            
            // Create a new IntersectionObserver
            const observer = new IntersectionObserver(observerCallback, observerOptions);
            
            // Start observing the anchor element
            observer.observe(anchorElement);
        });
    };
    
    // Initialize with default behavior (multiple active elements)
    isAnchorVisible('[is-anchor-visible]');
    
    // Example: Initialize with single active mode
    // isAnchorVisible('[is-anchor-visible]', { singleActive: true });
    
    // Or you can check for a data attribute to determine the mode
    // const container = document.querySelector('[is-anchor-visible-single]');
    // if (container) {
    //     isAnchorVisible('[is-anchor-visible]', { singleActive: true });
    // }
});